
import { Component, Vue, Watch } from 'vue-property-decorator';
import DataList from './components/AnnounceList.vue';

@Component({
  name: 'AnnouncementsList',
  components: {
    DataList
  }
})
export default class extends Vue {

}
